export const tooltip = {
	create(e) {
		if (this.tooltipElem) {
			this.tooltipElem.remove();
			this.tooltipElem = null;
		}
		let target = e.target;

		let tooltipHtml = target.dataset.tooltip;
		if (!tooltipHtml) return;

		this.tooltipElem = document.createElement("div");
		this.tooltipElem.className = "tooltip";
		this.tooltipElem.innerHTML = tooltipHtml;
		document.body.append(this.tooltipElem);

		let coords = target.getBoundingClientRect();

		let left =
			coords.left + (target.offsetWidth - this.tooltipElem.offsetWidth) / 2;
		if (left < 16) left = 16;

		let top = coords.top - this.tooltipElem.offsetHeight - 5;
		if (top < 0) {
			top = coords.top + target.offsetHeight + 5;
		}

		if (coords.right + 200 > document.body.offsetWidth) {
			this.tooltipElem.style.marginRight = "32px";
		}

		this.tooltipElem.style.left = left + "px";
		if (document.body.offsetHeight - coords.top > this.tooltipElem.offsetHeight + 20) {
			this.tooltipElem.style.top = top + this.tooltipElem.offsetHeight + "px";
		} else {
			this.tooltipElem.style.top = top + "px";
		}
	},
	delete() {
		if (this.tooltipElem) {
			this.tooltipElem.remove();
			this.tooltipElem = null;
		}
	}
}